import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'spe-doutor123',
    templateUrl: './doutor123.component.html',
    styleUrls: ['./doutor123.component.scss'],
    standalone: false
})
export class Doutor123Component implements OnInit {
  public image: string = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.image = this.data.image;
  }
}
